module.exports = __webpack_public_path__ + "static/media/arrow-3.f1652ea0.svg";